// extracted by mini-css-extract-plugin
export var sequence = "styles-module--sequence--1TVHc";
export var sequenceItem = "styles-module--sequenceItem--3C-tP";
export var activeItem = "styles-module--activeItem--1khDC";
export var recording = "styles-module--recording--14aYR";
export var sequencer = "styles-module--sequencer--2ATUY";
export var hideUI = "styles-module--hideUI--1vlV3";